import { Logger } from '../../services/log.service';

/**
 * Fetches the recolored icon-only SVG (no pin) for an asset type from the server (@see
 * `extractIconOnlySvg` in core-node) — used wherever the print export needs the real glyph as a plain
 * image rather than the Material Icons font (pdfMake's legend, and the map capture's marker, which
 * `html2canvas` doesn't reliably render as a font glyph). Returns `null` on any fetch failure.
 */
export async function fetchAssetTypeIconSvg(icon: string, color: string): Promise<string | null> {
	try {
		const url = `/v1/asset-type-icon/${encodeURIComponent(icon)}.svg?color=${encodeURIComponent(color)}`;
		const response = await fetch(url);
		return response.ok ? await response.text() : null;
	} catch (error) {
		Logger.error({ err: error, icon }, 'Failed to fetch asset type icon svg');
		return null;
	}
}

/** Wraps the SVG's content in a `<g>` rotated about its own viewBox center. A no-op at 0deg. */
export function rotateSvg(svg: string, degrees: number): string {
	if (degrees === 0) {
		return svg;
	}

	const viewBox = svg.match(/viewBox="([\d.-]+) ([\d.-]+) ([\d.-]+) ([\d.-]+)"/);
	const openTag = svg.match(/^<svg[^>]*>/);
	const closeIndex = svg.lastIndexOf('</svg>');
	if (viewBox == null || openTag == null || closeIndex === -1) {
		return svg;
	}

	const [, x, y, width, height] = viewBox.map(Number);
	const cx = x + width / 2;
	const cy = y + height / 2;
	const inner = svg.slice(openTag[0].length, closeIndex);
	return `${openTag[0]}<g transform="rotate(${degrees} ${cx} ${cy})">${inner}</g></svg>`;
}
